import types from '../../actions.types';

const { PENDING, SUCCESS, FAILED } = types.products;

const defaultState = {
  pending: false,
  data: [],
  error: null
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case PENDING:
      return Object.assign({}, state, { pending: true, error: null });
    case SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        data: action.data,
        error: null
      });
    case FAILED:
      return Object.assign({}, state, {
        pending: false,
        data: [],
        error: action.error.toString()
      });
    default:
      return state;
  }
}